module.exports = __webpack_public_path__ + "img/headingold.b482efde.svg";